<template>
  <div class="row align-items-center justify-content-center">
    <div class="col-md-12">
      <div class="mb-5 text-center margin-sm-f">
        <h1 class="text-white font-weight-bold">
          {{ $t("home.menuText1") }} <br />
          {{ $t("home.menuText2") }}
        </h1>
      </div>
      <form @submit.prevent="searchJobs" class="search-jobs-form">
        <div class="row mb-5 padding-xl">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-4 mb-lg-0">
            <vue-select
              :placeholder="$t('home.search')"
              @search="fetchDep"
              style="background: white; border-radius: 4px"
              class="style-choos-contract"
              v-model="depId"
              :options="depList"
              type="text"
              :label="$localeKey()"
              :reduce="(item) => item.id"
            ></vue-select>
          </div>
          <!--          <div class="col-12 col-sm-6 col-md-6 col-lg-2 mb-4 mb-lg-0">-->
          <!--            <button type="submit" class="btn btn-primary btn-lg btn-block text-white btn-search"><span-->
          <!--                class="icon-search icon mr-2">  {{ $t( "actions.filter" ) }}</span>-->

          <!--              &lt;!&ndash;              Search Vacancy&ndash;&gt;-->
          <!--            </button>-->
          <!--          </div>-->
        </div>
        <div class="display-table">
          <div class="display-table-cell">
            <div class="container">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <p
                    class="padding-t-15 home-desc text-white font-weight-bold"
                    style="font-size: 24px"
                  >
                    {{ $t("login.videoInfo") }} <br />{{
                      $t("login.videoLesson")
                    }}
                  </p>
                  <a
                    v-b-modal.modal
                    href="javascript: void(0);"
                    class="play-btn"
                  >
                    <div class="play-btn__icon">
                      <div class="play-icon"></div>
                    </div>
                  </a>

                  <b-modal
                    id="modal"
                    hide-footer
                    size="lg"
                    centered
                    header-close-variant="white"
                  >
                    <youtube
                      video-id="JUw9sE-eOBU"
                      ref="youtube"
                      style="width: 100%"
                    ></youtube>
                  </b-modal>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--        <div class="display-table">-->
        <!--          <div class="display-table-cell">-->
        <!--            <div class="container">-->
        <!--              <div class="row">-->
        <!--                <div class="col-lg-12 offset-lg-2 text-white text-center play-shadow  margin-l-r-auto">-->
        <!--                  <a v-b-modal.modal href="javascript: void(0);" class="play-btn">-->
        <!--                    <div class="play-btn__icon ">-->
        <!--                      <div class="play-icon"></div>-->
        <!--                    </div>-->
        <!--                  </a>-->
        <!--                  <div class="mb-5 text-center play-btn__text">-->
        <!--                    <div class="text-white font-weight-bold">Tanlovga hujjatlarni taqdim qilish <br>  bo'yicha video qo'llanma</div>-->
        <!--                  </div>-->
        <!--                  <b-modal id="modal" hide-footer size="lg" centered header-close-variant="white">-->
        <!--                    <youtube video-id="JUw9sE-eOBU" ref="youtube" width="750" height="450"></youtube>-->
        <!--                  </b-modal>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        -->
        <!--        -->
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      jobLocation: "",
      depId: "",
      staffPositionId: "",
      locationTypeId: "",
      data: {
        page: 0,
        limit: 20,
      },
    };
  },
  computed: {
    ...mapState("department", { depList: "list", total: "total" }),
  },
  watch: {
    jobLocation(value) {
      this.jobLocation = value;
    },
    depId: {
      deep: true,
      async handler(value) {
        if (value !== null) {
          await this.getDefaultAnnouncment({
            params: {
              params: this.data,
              depId: this.depId === null ? "" : this.depId,
              staffPositionId:
                  this.staffPositionId === null ? "" : this.staffPositionId,
              locationTypeId: null,
            },
            isArchive:false,
          });

          this.$emit("changeSelectedItem", value);
        }
      },
    },
  },

  methods: {
    ...mapState(["jobs"]),
    ...mapActions(["addJobs"]),
    ...mapActions("ennounsment", { getDefaultAnnouncment: "getList" }),
    ...mapActions("department", { getListDepartment: "getList" }),

    async fetchDep(search, loading) {
      this.params.search[this.$localeKey()] = search;
      await this.pageOptions(this.params);
    },
  },
  async created() {
    await this.getListDepartment();
    // await this.getDefaultAnnouncment( {
    //   params: this.data,
    //   depId: this.depId,
    //   staffPositionId: this.staffPositionId,
    //   locationTypeId: this.locationTypeId,
    // } );
  },
};
</script>


<style>
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 575px) {
  .padding-xl {
    padding-bottom: 0px !important;
  }
  .margin-sm-f {
    margin-top: 100px !important;
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    width: 100%;
  }
}


@media only screen and (max-width: 1024px) and (min-width: 575px) {
  .padding-xl {
    padding-bottom: 0px !important;
  }
  .margin-sm-f {
    margin-top: 50px;
    display: flex;
    justify-content: center !important;
    align-items: center !important;
    width: 100%;
  }
}

.padding-xl {
  padding-bottom: 100px;
}
.margin-sm-f{
}
</style>
<style scoped>
.vs__search,
.vs__search:focus {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  line-height: 1.4;
  font-size: 1em;
  border: 1px solid transparent;
  border-left: none;
  outline: none;
  margin: 4px 0 0;
  padding: 7px 7px;
  background: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 0;
  max-width: 100%;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  z-index: 1;
}

.display-table-cell {
  display: table-cell;
  vertical-align: middle;
}

.display-table {
  display: table;
  width: 100%;
  height: 100%;
}

.home-up {
  z-index: 10;
  position: relative;
}

.play-btn {
  width: 80px;
  height: 80px;
  display: block;
  font-size: 30px;
  margin-right: auto;
  margin-left: auto;
  line-height: 60px;
  margin-top: 10px;
  text-align: center;
}

.play-shadow {
  border-radius: 50%;
  border: 1px solid transparent;
  width: 82px;
  height: 82px;
  margin: 20px auto;
}

/*!*.play-shadow {*!*/
/*!*  border-radius: 50%;*!*/
/*!*  border: 1px solid transparent;*!*/
/*!*  width: 82px;*!*/
/*!*  height: 82px;*!*/
/*!*  margin: 20px auto;*!*/
/*!*}*!*/

/*.home-desc {*/
/*  color: rgba(255, 255, 255, 0.7);*/
/*  font-size: 15px;*/
/*  max-width: 600px;*/
/*  margin: 0 auto;*/
/*}*/

::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}

::v-deep .modal-header {
  border: none;
}

::v-deep .modal-backdrop {
  opacity: 0.1;
}

/*.play-btn {*/
/*  position: absolute;*/
/*  display: block;*/
/*  color: #ffffff;*/
/*  font-size: 36px;*/
/*  text-decoration: none;*/
/*  font-family: Ubuntu;*/
/*  font-weight: bold;*/
/*  margin-right: auto;*/
/*  margin-left: auto;*/
/*  line-height: 60px;*/
/*  margin-top: 10px;*/
/*  text-align: center;*/
/*  !*top: 100px; !* tikai priekš codepen *!*!*/
/*  !*right: 50%; !* tikai priekš codepen *!*!*/

/*}*/
/*.play-btn {*/

/*}*/

.play-btn__icon {
  position: relative;
  float: left;
  width: 100px;
  height: 100px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
  background-color: #fff;
  -webkit-box-shadow: 0 5px 15px rgba(1, 1, 1, 0.55),
    inset 0 2px 2px rgba(255, 255, 255, 0.25);
  -moz-box-shadow: 0 5px 15px rgba(1, 1, 1, 0.55),
    inset 0 2px 2px rgba(255, 255, 255, 0.25);
  box-shadow: 0 5px 15px rgba(1, 1, 1, 0.55),
    inset 0 2px 2px rgba(255, 255, 255, 0.25);
  background-image: -webkit-linear-gradient(top, #67af46, #428324);
  background-image: -moz-linear-gradient(top, #67af46, #428324);
  background-image: -o-linear-gradient(top, #67af46, #428324);
  background-image: -ms-linear-gradient(top, #67af46, #428324);
  background-image: linear-gradient(to bottom, #67af46, #428324);
}

.play-btn:hover .play-btn__icon {
  background-color: #fff;
  -webkit-box-shadow: 0 3px 8px rgba(1, 1, 1, 0.55),
    inset 0 2px 2px rgba(255, 255, 255, 0.15);
  -moz-box-shadow: 0 3px 8px rgba(1, 1, 1, 0.55),
    inset 0 2px 2px rgba(255, 255, 255, 0.15);
  box-shadow: 0 3px 8px rgba(1, 1, 1, 0.55),
    inset 0 2px 2px rgba(255, 255, 255, 0.15);
  background-image: -webkit-linear-gradient(bottom, #67af46, #428324);
  background-image: -moz-linear-gradient(bottom, #67af46, #428324);
  background-image: -o-linear-gradient(bottom, #67af46, #428324);
  background-image: -ms-linear-gradient(bottom, #67af46, #428324);
  background-image: linear-gradient(to top, #67af46, #428324);
}

.play-icon {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-left: 32px solid #ffffff;
  border-bottom: 15px solid transparent;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 50%;
  margin-left: -14px;
}

/*.play-btn__text {*/
/*  margin-left: 30px;*/
/*  font-size: 30px;*/
/*  float: left;*/
/*}*/

.modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}

.modal-header {
  border: none;
}

a:hover {
  color: #fff;
}
</style>
